import { default as SidebarMenuModule } from "./leftMenu-module";

export { SidebarMenuModule };
export default SidebarMenuModule;
